import {searchModel} from "../../../../Utilities/Search";

export const aphLoanHistorySearchModel = (studentId = "", patronId = "", shippingLocationId = "", aphCatalogTitle = "", aphLoanStatus = "", isAphLoanHistory = true, districtId = "", organization = "") => {
    return Object.assign({}, searchModel(patronId.toString(), "aphCatalogTitle", false, "aphCatalogTitle"), {
        studentId,
        patronId,
        shippingLocationId,
        aphCatalogTitle,
        aphLoanStatus,
        isAphLoanHistory,
        districtId,
        organization,
        ClearLoanHistorySearch: clearAphLoanHistorySearch,
    });
};

function clearAphLoanHistorySearch(this: Record<string, unknown>) {
    this.aphCatalogTitle = "";
    this.patronId = "";
    this.shippingLocationId = "";
    this.studentId = "";
    this.aphLoanStatus = "";
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}
